import type { FaireProductEntity } from "../../entity_types/product";

export const p_p79xnpg4sw: FaireProductEntity = {
  token: "p_p79xnpg4sw",
  type: "product",
  name: "100% Pure Wool Triangular Scarf Women's Knit Winter Scarf",
  brandToken: "b_5qb9p6vh8d",
  brandName: "SALINA TRADING INC",
  imageUrl:
    "https://cdn.faire.com/fastly/cbc3eb615f348bb16185cf9f59613630a5727cd5804b6907942b54ef328382d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/320372ce449b2b1c15713c4df70543951d5dc6e96d3551d6d06b44186f21bfea.jpeg",
    "https://cdn.faire.com/fastly/ee996c0c82f58616269949417a49b9ce734141e5c2d0dc60ead8da6bf317c972.jpeg",
    "https://cdn.faire.com/fastly/0f26489b2f6f3fb1eb8900da76a69b300992e99c2da56ccb85defeea3fc1e529.jpeg",
    "https://cdn.faire.com/fastly/caf91f9e7590af041c783b7a39b76803aa32487bd17715d2633e9989d627bad3.jpeg",
    "https://cdn.faire.com/fastly/3d482efce10460a6d6d3d16d8838798eb8ea366a7023fe8c629ac245722a5c34.jpeg",
    "https://cdn.faire.com/fastly/9b4f8d4f15a7966715f31934d22fcdbb40608c7fae224a9ef1a56a7b1d60694d.jpeg",
    "https://cdn.faire.com/fastly/64c0956b0c08c82740442e6596e746413283aa492a15a2a7316d48aab546cd6b.jpeg",
  ],
  priceDollars: 12.25,
  description:
    "This chic triangular scarf is the perfect accessory for the fall and winter seasons, designed to keep you warm while adding a unique touch to your outfit. Made from 100% pure wool, it features a stylish open-knit design that is both trendy and functional. Available in three beautiful colors, this scarf is ideal for layering and elevating your winter looks.\nFeatures: \n * Material: 100% Pure Wool \n * Dimensions: 130 x 50 cm \n * Stylish open-knit design for a fashionable touch \n * Available in Pink, Blue, and Off-White \n * Versatile for various styling options \n * Perfect for winter wear \nEmbrace the colder months with this lightweight yet warm triangular scarf, perfect for adding flair to your winter wardrobe. Its elegant design and soft texture make it an essential piece for any fashion-forward individual.\n",
  tags: [],
  msrpDollars: 24.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:48.627Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
